import React from 'react';
import { Box, keyframes } from '@mui/material';

const bounce = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
`;

const TypingIndicator: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        py: 1
      }}
    >
      {[0, 1, 2].map((index) => (
        <Box
          key={index}
          sx={{
            width: 8,
            height: 8,
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            borderRadius: '50%',
            animation: `${bounce} 1.4s infinite`,
            animationDelay: `${index * 0.16}s`
          }}
        />
      ))}
    </Box>
  );
};

export default TypingIndicator;